<template>
  <div>
    <v-app class="p-4">

      <!--      start edit mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="editModal"
              max-width="900"
              hide-overlay
              transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar
                  flat
                  dark
                  color="primary"
              >

                <v-toolbar-title>ویرایش آگهی</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                      icon
                      dark
                      @click="editModal = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <create-tarefe :editProps="editProps"></create-tarefe>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->

      <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
        <div class="mt-5 pt-5">
          <v-card :loading="loading" class="p-3 pt-0 mt-4">
            <terminal-table :currentPage="datas.current_page"
                            :perPage="datas.per_page" v-if="isMobile" :getData="getDataForTable"
                            :pageCount="datas.last_page"
                            :options="tableProps" :datas="datas" :headers="columns"></terminal-table>

            <data-table
                v-else
                :orderBy="tableProps.column"
                :orderDir="tableProps.dir"
                :data="datas"
                :pagination="paginate"
                :columns="columns"
                :debounce-delay="3000"
                :translate="translate"
                :per-page="[10, 25, 50, 100, 500]"
                @on-table-props-changed="reloadTable"
                class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
            >
              <template slot="filters" slot-scope="{ tableFilters, perPage }">
                <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                               v-model="searchBox"></filters-table>
              </template>
            </data-table>
          </v-card>
        </div>

      </div>
    </v-app>
  </div>
</template>

<script>
import button from "@/view/pages/button";
import {dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import {debounce} from "../../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "futureList",
  components: {FiltersTable, TitleRibbon, button, dataTableProps, createTarefe},
  props: {
    editProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tarafeName: "",
      editModal: false,
      loading: false,
      datas: {},
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      url: `${url}/advertise/list/future`,
      selectedNumber: [],
      dataId: '',
      deleteID: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.datas.current_page - 1;
            row = row * this.datas.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'شماره',
          name: 'number.phone',
          orderable: true,
          searchable: true,
        },
        {
          label: 'موضوع',
          name: 'title',
          orderable: true,
          searchable: true,
        },
        {
          label: 'تاریخ ارسال',
          name: 'available_at_p',
          orderable: true,
          searchable: true,
        },
        {
          label: 'مدیریت',
          name: 'delete',
          transform: (val) => {
            return `<button class="btn btn-xl text-danger  text-center delete fa fa-trash-alt text-center" data-id="${val.data.id}"></button>`
          },
        }
      ],
      searchBox: {
        search: '',
        length: 10
      },

    }
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }

  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: query,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.datas = data;
          vm.loading = false
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 700);
    },
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url)

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    })

    let deleteAds = (element) => {
      this.deleteID = element.target.dataset.id;
      this.$modal.yesNo('تایید حذف!', 'آیا از حذف آگهی اطمینان دارید؟', 'neg').then((res) => {
        if (res) {
          $.ajax({
            url: `${url}/advertise/list/future/${this.deleteID}`,
            type: 'DELETE',
            fn: this.deleteAds,
            msg: true,
            headers: {
              Authorization: Token,
              ACCEPT: 'application/json',
              "Content-type": "application/json"
            },
            success: (res) => {
              this.reloadTable();
              element.unbind();
            }
          })
        }
      })

    }
    $(document).on('click', `.delete`, deleteAds);
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
}
</script>

<style scoped>

</style>